/* eslint-disable func-style */
import { Button, FloatingLabel, Form } from "react-bootstrap";
import { sortBy, unescape, union, uniqBy } from "lodash";
import { useCallback, useEffect } from "react";

import { useClassFilters } from "./ClassFilterProvider";

const FilterFacets = () => {

	const {
		allFacets,
		setAllFacets,
		facets,
		facetValues,
		setFacetValues,
		handleFacetChange: onChange,
		toggleFilters: handleSeeClasses
	} = useClassFilters();

	const handleChange = useCallback(({ target }) => {
		setFacetValues((prevValues) => ({
			...prevValues,
			[target.name]: target.value
		}));
	}, [setFacetValues]);

	useEffect(() => {
		window.localStorage.setItem("eventFacets", JSON.stringify(facetValues));
		onChange(facetValues);
	}, [facetValues]);

	useEffect(() => {
		setAllFacets((currentAllFacets) => facets.map((facet, idx) => {
			let choices = union(facet.choices, currentAllFacets[idx]?.choices);
			choices = uniqBy(choices, (choice) => choice.value);
			choices = sortBy(choices, [(choice) => choice.label]);
			return {
				...facet,
				choices
			};
		}));
	}, [facets, setAllFacets]);

	const resetFilters = useCallback((evt) => {
		evt.preventDefault();
		setFacetValues({});
	}, []);

	return (
		<>
			{allFacets
				? allFacets.map((facet) => facet.choices && !!facet.choices.length && (
					<Form.Group className="mb-4" key={facet.name}>
						<FloatingLabel
							controlId={facet.name}
							label={facet.label}
						>
							<Form.Select
								name={facet.name}
								onChange={handleChange}
								placeholder={facet.label}
								value={facetValues[facet.name] || ""}
							>
								<option value="">Select one...</option>
								{facet.choices.map((choice) => choice.label && (
									<option
										defaultChecked={facetValues[facet.name] === unescape(choice.label)}
										key={unescape(choice.value || choice.label)}
										value={unescape(choice.label)}
									>
										{unescape(choice.label)}
									</option>
								))}
							</Form.Select>
						</FloatingLabel>
					</Form.Group>
				)) : null}

			<div className="d-grid">
				{!!handleSeeClasses && <Button onClick={handleSeeClasses}>
					See Events &amp; Group
				</Button>}
				<Button onClick={resetFilters} variant="link">
					Reset Filters
				</Button>
			</div>
		</>
	);
};

export default FilterFacets;
